import {get,post,url} from '../http'

class About{
    //加入我们
    @url("join")
    @get
    getlist(){}


}

export default new About()